module.exports = __webpack_public_path__ + "img/logobg.e5cfe3d8.png";